// extracted by mini-css-extract-plugin
export default {"box":"AddTags_box__Zn7ch","selectTitle":"AddTags_selectTitle__sY+o9","title":"AddTags_title__wpSp9","inputTitle":"AddTags_inputTitle__IAYBB"};